import { styled } from "@mui/material";

import { SoapNotesStatuses } from "../../redux/API/ClientAPIHelpers/dataCollectionProperties";
import { useSelector } from "../../redux/store";
import { AdminTypes } from "../../components/Menu";

export const HeaderWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  "&>div": {
    width: "50%",
  },
}));

export const useIsActionAllowed = (status: number, noteUserId: string) => {
  const role = useSelector((state) => state.account.role);
  const userId = useSelector((state) => state.account.user.id);

  const canUserEdit = noteUserId === userId || role?.section.id === AdminTypes.admin;

  if (
    status === SoapNotesStatuses.submitted ||
    status === SoapNotesStatuses.expired48 ||
    status === SoapNotesStatuses.expiredWeek ||
    !canUserEdit
  ) {
    return false;
  }

  return true;
};